import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import InstaToolPricingCard from "./components/InstaToolPricingCard";
import { getVisibleInstaToolPlans } from "./data/instaToolPricing.config";
import { useSelector } from "react-redux";
import { selectInfluencerPlanType } from "../../Redux/userSlice";

const InstaToolPricingPage = () => {
  const currentPlanType = useSelector(selectInfluencerPlanType);
  const visiblePlans = getVisibleInstaToolPlans(currentPlanType);

  return (
    <>
      <Navbar />

      <main className="min-h-screen bg-gray-50">
        <div className="mx-auto max-w-6xl px-6 py-16">
          <header className="mx-auto max-w-2xl text-center">
            <h1 className="text-2xl font-bold md:text-4xl">
              Insta Tools Pricing
            </h1>
            <p className="mt-3 text-sm text-gray-600 md:text-base">
              Start free with media dashboards, or upgrade to automate DMs,
              generate links, and grow through the Infuber marketplace.
            </p>
          </header>

          <section
            className="mt-10 flex flex-col items-stretch justify-center gap-6 md:flex-row lg:mt-12"
            aria-label="Insta Tools pricing plans"
          >
            {visiblePlans.map((plan) => (
              <InstaToolPricingCard key={plan.id} plan={plan} />
            ))}
          </section>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default InstaToolPricingPage;
